export default {
	name: 'Gabriel Schneider',
	
	instagram_link: 'https://www.instagram.com/gabs_schneider/',
	medium_link: 'https://medium.com/@gabrielschneider_72533',
	messenger_link: 'https://m.me/gabriel.schneider.1840',
	whatsapp_link: 'https://api.whatsapp.com/send?phone=5515997953510',
	phone_number: '5515997953510',
	
	menu_info_name: 'Gabriel Schneider',
	menu_info_details: 'Design e Desenvolvimento de Aplicativos e Sites',
	menu_contact_email: 'contato@gabrielsch.com',
	menu_contact_cel: '+55 15 99795 3510',
	
	hero_greeting: 'OI.',
	hero_intro_title: 'Meu nome é Gabriel Schneider',
	hero_intro_description: 
		'Eu crio e desenvolvo aplicativos, sites e aplicações inteligentes. '
		+ 'Eu ajudo pessoas e negócios a lançar seus produtos digitais, analisar '
		+ 'seu desempenho e traçar estratégias para melhorias e crescimento.',						

	bio_title: {
		t1: 'Designer',
		t2: 'Desenvolvedor',
		t3: 'Pensador'
	},
	bio_info_p1: 
		'Antes de começar a desenvolver aplicações profissionalmente eu '
		+ 'estudei, fiz intercâmbio, viajei e conheci pessoas novas e de diferentes '
		+ 'nacionalidades. Após algum tempo tentando entender meu lugar no mundo, percebi '
		+ 'que poderia usar meus conhecimentos técnicos e humanos para ajudar outras pessoas '
		+ 'a atingirem seus objetivos e dar vida a suas ideias.',
	bio_info_p2: 
		'Criar aplicações não é apenas programar telas e funcionalidades, existe toda uma '
		+ 'preparação e estudo que leva ao produto que seus usuários irão receber. '
		+ 'Um produto útil, amável e que desperte o interesse de quem o usa. Criar '
		+ 'é uma arte, uma ciência, uma filosofia.',
	bio_info_p3: 
		'Por isso, ter a ajuda de alguém que entende do assunto é essencial para garantir que seu '
		+ 'produto ofereça a melhor solução possível para seus usuários. Seu site ou aplicativo será sua '
		+ 'conexão digital com seus clientes, então vale a pena investir em uma solução de qualidade.',
	bio_info_p4: 
		'Eu adoraria te ajudar com seus projetos e te auxiliar a criar uma experiência digital única e '
		+ 'criativa para seus clientes. Entre em contato comigo para que possamos conversar sobre novas ideias.',
	bio_action: 'ENTRAR EM CONTATO',

	project_intro_goal: 'Objetivo',
	project_intro_result: 'Resultado',
	project_links_web: 'Ir para o site',
	project_links_ios: 'Baixe na Apple Store',
	project_links_android: 'Baixe na Google Play',

	footer_info: '© 2018 Gabriel Schneider. Todos os direitos reservados.'
}


// WEBPACK FOOTER //
// ./src/values/strings/strings-br.js